import React from 'react';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
import { CTAButton } from './shared/CTAButton';
import { CountdownTimer } from './shared/CountdownTimer';
export function PricingSection() {
  return <SectionWrapper bg="blush" id="comprar" className="relative overflow-hidden" data-id="element-184">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white rounded-full blur-3xl opacity-60 -z-10 pointer-events-none" data-id="element-185"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-186">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border-2 border-rose/20 relative" data-id="element-187">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-rose text-white px-6 py-2 rounded-full font-bold text-sm tracking-widest uppercase shadow-md" data-id="element-188">
            Oferta Especial
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4 mt-4" data-id="element-189">
            Accedé hoy por $29 USD{' '}
            <span className="text-xl md:text-2xl text-warm-muted font-normal" data-id="element-190">
              (pago único)
            </span>
          </h2>

          <p className="text-warm-muted font-medium mb-8" data-id="element-191">
            No es una suscripción. No hay mensualidades.{' '}
            <strong className="text-rose" data-id="element-192">Es tuyo para siempre.</strong>
          </p>

          <div className="flex flex-col items-center justify-center gap-2 mb-6" data-id="element-193">
            <span className="text-warm-muted line-through text-xl" data-id="element-194">
              Precio regular: $99.99 USD
            </span>
            <div className="text-6xl md:text-7xl font-serif font-bold text-rose drop-shadow-sm" data-id="element-195">
              $29 USD
            </div>
          </div>

          <p className="text-sm text-rose-light italic font-medium mb-8" data-id="element-196">
            *El precio de $29 USD es promocional de lanzamiento.
            <br data-id="element-197" />
            Cuando el contador llegue a cero, el programa vuelve a precio
            regular automáticamente.*
          </p>

          <CountdownTimer data-id="element-198" />

          <div className="mt-10 mb-6" data-id="element-199">
            <CTAButton className="text-lg md:text-xl px-12 py-6 w-full shadow-glow" data-id="element-200">
              ACCEDER AHORA POR $29 USD
            </CTAButton>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-warm-muted font-medium bg-cream py-4 rounded-xl border border-blush" data-id="element-201">
            <span className="flex items-center gap-1.5" data-id="element-202">
              <Lock className="w-4 h-4 text-success" data-id="element-203" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-204">
              <Zap className="w-4 h-4 text-gold" data-id="element-205" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-206">
              <ShieldCheck className="w-4 h-4 text-rose" data-id="element-207" /> Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}